<template>
<div v-if="display_row" class="row align-items-center my-3">
    <div v-if="merge_status === 'error'" class="col-12">
        <div class="alert alert-danger">
            Uh oh. Something went wrong. Check your selections and try again.
        </div>
    </div>
    <template v-for="physician, key in physician_group.slice(0,2) ">
        <div class="col" :class="{'pending' : merge_status === 'pending'}">
            <div class="card physician mb-0" @click="toggleToMerge(physician.id)" :class="selected.includes(physician.id) ? 'selected' : ''">
                <div class="card-body">
                    <div class="d-flex mb-2">
                        <div class="flex-grow-1">
                            <router-link :to="{ name: 'physicians.show', params: { id: physician.id } }" class="font-weight-bold">{{ physician.display_name }}</router-link>
                            <span v-for="specialty in physician.specialties" class="badge badge-primary mr-1">{{ specialty.label }}</span>
                            <i v-if="physician.system_links.length > 0" class="fal fa-link text-sm text-gray-500"></i>
                        </div>
                        <span v-if="key === 1 && physician_group.length > 2" class="text-gray-500"><strong>+ {{ physician_group.length - 2}} more</strong></span>
                    </div>                            

                    <div class="d-flex">                        
                        <div v-if="physician.location_primary && physician.location_primary.formatted_address" class="flex-grow-1 media">
                            <i class="fas fa-map-marker-alt text-gray-500 mr-1 mt-1" style="width:16px;"></i>
                            <div class="media-body" v-html="physician.location_primary.formatted_address">
                              
                            </div>
                        </div>
                        <div class="flex-grow-1">
                            <div class="media mb-2">
                                <i class="fal fa-check-circle text-gray-500 mr-1 mt-1" style="width: 16px;"></i>
                                <div class="media-body">
                                    <strong>{{ physician.checkins_count || 0 }}</strong> checkins
                                </div>
                            </div>
                            <div class="media mb-2">
                                <i class="fal fa-star text-gray-500 mr-1 mt-1" style="width: 16px;"></i>
                                <div class="media-body">
                                    <strong>{{ physician.referrer_score || 0 }}</strong> Referrer Score
                                </div>
                            </div>
                            <div class="media">
                                <i class="fal fa-user-injured text-gray-500 mr-1 mt-1" style="width: 16px;"></i>
                                <div class="media-body">
                                    <strong>{{ physician.referred_patients || 0 }}</strong> Referred Patients
                                </div>
                            </div>
                        </div>
                    </div>                                                         
                </div>
            </div>
        </div>

        <div
            v-if="key == 0"
            style="position:relative"
            class="direction"
            :class="{'pending' : merge_status === 'pending'}">

            <img v-if="merge_status === 'pending'" class="center-me" src="/images/loading-color.svg">

            <i :class="'mx-2 text-gray-500 fa fa-arrow-' + direction"
                @click="toggleMergeDirection(direction)"
                style="font-size:2.5rem">
            </i> 
        </div>         
    </template>

    <div class="col">
        <div v-if="selected.length >= 2" class="form-group">
            <div class="section-label">Items to merge</div>
            <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="record_merge.items" value="campaign_visits"> Campaigns
            </div>
            <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="record_merge.items" value="checkins"> Checkins
            </div>                        
            <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="record_merge.items" value="locations"> Locations
            </div>           
            <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="record_merge.items" value="notes"> Notes
            </div>
            <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="record_merge.items" value="route_visits"> Routes (reqs checkins and locations)
            </div>                                                             
            <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="record_merge.items" value="specialties"> Specialties
            </div>
            <div class="form-check">
                <input class="form-check-input" type="checkbox" v-model="record_merge.items" value="tasks"> Tasks
            </div>
        
            <div class="mt-1">
                <button type="button" class="btn btn-sm btn-ghost-secondary" @click="mergeCancel()">Cancel</button>
                <button type="button" class="btn btn-sm btn-primary" @click="mergeSave()">Merge</button>
            </div>
        </div> 


    </div>

</div>
</template>

<script>

	export default {
		props: ['physician_group'],

		data() {
			return {
                display_row: true,
                showform: false,

                selected: [],
                direction: 'right',

                merge_status: 'none',

                record_merge: {
                    mergees: [],
                    dest_physician: null,
                    items: [
                        'notes',
                        'checkins',
                        'campaign_visits',
                        'route_visits',
                        'specialties',
                        'locations',
                        'tasks'
                    ],
                },
			}
		},

		methods: {
            setDisplayProperties() {
                if (this.physician_group.length === 2) {
                    this.display_row = false;
                }
                if (this.physician_group.length > 2) {
                    //remove the mergee physician from the group
                    this.physician_group.splice(
                        this.physician_group.findIndex(physician => { 
                            return physician.id === this.record_merge.mergees[0];
                        }), 1
                    )
                    //and from selected
                    this.selected.splice(
                        this.physician_group.findIndex(physician => { 
                            return physician.id === this.record_merge.mergees[0];
                        }), 1
                    )
                }
            },

            setMergeIds() {
                //do nothing if only one record selected
                if (this.selected.length > 1) {
                    if (this.direction === 'right') {
                        this.record_merge.dest_physician = this.physician_group[1].id;
                        this.record_merge.mergees.length = 0;
                        this.record_merge.mergees.push(this.physician_group[0].id);
                    }

                    if (this.direction === 'left') {
                        this.record_merge.dest_physician = this.physician_group[0].id;
                        this.record_merge.mergees.length = 0;
                        this.record_merge.mergees.push(this.physician_group[1].id);
                    }
                }
            },

            toggleMergeDirection(direction) {
                if (direction === 'right') {
                    this.direction = 'left';
                }
                if (direction === 'left') {
                    this.direction = 'right';
                }
            },

            toggleToMerge(physicianId) {
                if (this.selected.includes(physicianId)) {
                    this.selected.splice(
                        this.selected.findIndex(element => { return element === physicianId }), 1
                    );
                }
                else {
                    this.selected.push(physicianId);
                }
            },

            mergeCancel() {
                this.toggleToMerge(this.selected[1]);
                this.toggleToMerge(this.selected[0]);
            },

            mergeSave() {
                Swal.fire({
                      title: 'Are you sure?',
                      text: 'The selected items will be merged and orphaned physician record will be deleted.',
                      icon: 'warning',
                      showCancelButton: true,
                      confirmButtonText: 'Merge physician',
                      cancelButtonText: 'Keep physician',
                      animation: false,
                }).then((result) => {
                    if (result.value) {
                        this.merge_status = 'pending';                
                        axios.post('/api/physicians/merge', this.record_merge).then((data) => {
                            this.merge_status = 'complete';

                            this.setDisplayProperties();

                            Swal.fire({
                                toast: true,
                                position: 'top-end',
                                showConfirmButton: false,
                                timer: 3000,
                                icon: 'success',
                                title: 'Physicians Merged',
                            });
                            this.$store.dispatch('refreshPhysicianIds');
                            this.$store.dispatch('refreshMappablePhysicianIds');                                     
                        }).catch((error) => {
                            this.merge_status = 'error';
                        })
                    }
                });
            },

		},

		watch: {
            //arrow click changes
            direction() {
                this.setMergeIds();
            },

            //need to watch selected as well, since direction has a default
            selected() {
                this.setMergeIds();
            },
		},

	}

</script>

<style scoped>
    .card.physician:hover {
        cursor:pointer;
        border:1px solid #b7b8b9;
        transition:.2s ease-in all;
        box-shadow: 2px 2px 2px rgba(0,0,0,.03);
    }

    .card.selected {
        background-color:#e9ecef;
        border:1px solid #b7b8b9;
    }

    .direction.pending > i {
        opacity:0;
        transition:.2s ease-in all;      
    }
</style>